import { render, staticRenderFns } from "./InventoryCardSendButton.vue?vue&type=template&id=54750f70&scoped=true"
import script from "./InventoryCardSendButton.vue?vue&type=script&lang=js"
export * from "./InventoryCardSendButton.vue?vue&type=script&lang=js"
import style0 from "./InventoryCardSendButton.vue?vue&type=style&index=0&id=54750f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54750f70",
  null
  
)

export default component.exports